import { Component } from 'react';

import { Button, Header, Message, Form, Input } from 'semantic-ui-react'

import admin_users_model_base from 'models/admin_users_model_base'

/**
 * @deprecated This component will be removed in the near future - functionality is covered in AdminIdpUsers
 */
export default class AdminUserLegacy_profile_auth extends Component {

	constructor(props) {
		super(props);

		this.state = {
				iniemail: props.user.email,
				ininame: props.user.displayName,
				newemail: props.user.email,
				newname: props.user.displayName,
				password: '',
				message: '',
				loading: false,
				error: false
			};
	}

	// 		--------------------------------		--------------------------------		---------

	static getDerivedStateFromProps(nextProps, prevState) {
		return {
				newemail: nextProps.user.email==prevState.iniemail ? prevState.newemail : nextProps.user.email,
				newname: nextProps.user.displayName==prevState.ininame ? prevState.newname : nextProps.user.displayName,
			}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	setNewEmail = () => {
		const { user } = this.props
		let { newemail } = this.state

		newemail = newemail.trim().replace(/[\u200B-\u200D\uFEFF]/g, '');

		if (newemail==user.email || !newemail) 			return

		console.log("sending newemail %o to user %o", newemail, user)

		this.setState({
						message:'',
						error:false,
						loading:true
					})

		admin_users_model_base.set_user_newemail( user, newemail, 
			result => {
				console.log("result = %o", result)
				this.setState({
								newemail: '',
								message: result.res=='ok' && 'New email set' || result.err_msg,
								error: result.res != 'ok',
								loading: false
							})
			} )
	}

	// 		--------------------------------		--------------------------------		---------


	setNewName = () => {
		const { user } = this.props
		const { newname } = this.state

		if (newname == user.displayName) 			return

		console.log("sending newname %o to user %o", newname, user)

		this.setState({
						message:'',
						error:false,
						loading:true
					})

		admin_users_model_base.set_user_newname( user, newname, 
			result => {
				console.log("result = %o", result)
				this.setState({
								newname: '',
								message: result.res=='ok' && 'New name set' || result.err_msg,
								error: result.res != 'ok',
								loading: false
							})
			} )
	}

	// 		--------------------------------		--------------------------------		---------

	sendPassword = () => {
		const { user } = this.props
		const { password } = this.state

		if (password == '') 			return

		console.log("sending password %o to user %o",password,user)

		this.setState({
						message:'',
						error:false,
						loading:true
					})

		admin_users_model_base.send_user_password( user, password, 
			result => {
				console.log("result = %o",result)
				this.setState({
								password: '',
								message: result.res=='ok' && 'New password sent' || result.err_msg,
								error: result.res != 'ok',
								loading: false
							})
			} )
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	render() {
		const { user } = this.props
		const { password, newname, newemail, message, error, loading } = this.state


		return <div style={{width: '600px'}}>

			<h2>Edit user profile details for user <br/> {user.displayName} {user.email}</h2>

				{message && 
					<Message negative={error} positive={!error}>
						<p>{message}</p>
					</Message>
				}

			<hr />
			<br />

			<Form loading={loading} autoComplete="off">

				<Header as="h3">Set and Send new password</Header>

				<Form.Input
					label="New password"
					fluid
					placeholder='Password'
					value={password} 
					onChange={(e,{value})=>this.setState({password:value})}  
					type='text' 
				/>

				<Button type='submit' disabled={password==''} onClick={this.sendPassword} >Submit</Button>

			<br />
			<br />
			<hr />

				<Header as="h3">Rename user</Header>

				<Form.Field>
					<label>New name</label>

					<Input 
							// icon='lock' 
							// iconPosition='left' 
							fluid 
							placeholder={user.displayName}  
							// name='name' 
							value={newname} 
							onChange={(e,{value})=>this.setState({newname:value})}  
							type='text' 
						/>
				</Form.Field>

				<Button 
						type='submit' 
						disabled={newname==user.displayName} 
						onClick={this.setNewName} 
						content='Submit'
					/>

			<br />
			<br />
			<hr />

				<Header as="h3">Change email. Login details will change!</Header>

				<Form.Field>
					<label>New email</label>

					<Input 
							// icon='lock' 
							// iconPosition='left' 
							fluid 
							placeholder={user.email}  
							// name='name' 
							value={newemail} 
							onChange={(e,{value})=>this.setState({newemail:value})}  
							type='text' 
						/>
				</Form.Field>

				<Button 
						type='submit' 
						disabled={newemail==user.email || !newemail} 
						onClick={this.setNewEmail} 
						content='Submit'
					/>

			</Form>

		</div>
	}

}
